import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import CustomTheme from '../assets/themes/theme'
import es from 'vuetify/es5/locale/es'
import '@mdi/font/css/materialdesignicons.css'


Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: CustomTheme.light,
            pantone: '#B08C55',
            pantoneBlack: '#15212F'
        },
        options: { customProperties: true }
    },
    lang :{
        locales: {es},
        current: 'es'
    }
});
